import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import ArrowBack from '@mui/icons-material/ArrowBack';

export default function SharedBackButton({ to }: { to?: string }) {
  return (
    <Button
      startIcon={<ArrowBack />}
      component={Link}
      relative="path"
      to={to ?? '..'}
      disableElevation
      color="inherit"
      sx={{
        textTransform: 'none',
        width: 'fit-content',
        minWidth: 0,
        ml: '4px',
        mt: '4px',
      }}
    >
      Back
    </Button>
  );
}
